import { gql, useMutation } from "@apollo/client";
import { ApolloMutationTuple } from "../../types/types";
import { DeleteAppRoleMutation } from "../customQueries/nested/API";
import { deleteAppRole } from "../customQueries/nested/mutations";

const useAppRoleDelete = (): ApolloMutationTuple<DeleteAppRoleMutation> => useMutation(gql(deleteAppRole));

export default useAppRoleDelete;
